import React from 'react';

import { ReactComponent as TwitterIcon } from '@pkg/assets/icons/v2/social/twitter.svg';

import { ConnectedBadgeLabel, ConnectedBadgeWrapper, ConnectedBulletPoint, TwitterBadgeWrapper } from './styles';

export const TwitterBadge = () => {
    return (
        <TwitterBadgeWrapper>
            <TwitterIcon />
        </TwitterBadgeWrapper>
    );
};

interface ConnectedBadgeProps {
    isMobile?: boolean;
}

export const ConnectedBadge = ({ isMobile = false }: ConnectedBadgeProps) => {
    return (
        <ConnectedBadgeWrapper isMobile={isMobile}>
            <ConnectedBulletPoint />
            <ConnectedBadgeLabel>Connected</ConnectedBadgeLabel>
        </ConnectedBadgeWrapper>
    );
};
